import toast from "react-hot-toast";

export const copyToClipboard = (value: string) => {
  const text = value;

  navigator.clipboard
    .writeText(text)
    .then(() => {
      toast.success("¡Contacto copiado al portapapeles!");
    })
    .catch(() => {
      toast.error("No se pudo copiar al portapapeles");
    });
};

export const isDesktopDevice =
  typeof window !== "undefined"
    ? window.matchMedia("(pointer: fine) and (hover: hover)").matches
    : false;

export const isPhoneDevice =
  typeof window !== "undefined"
    ? /android.*mobile|iphone/i.test(window.navigator.userAgent)
    : false;
